var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isGifShow)?_c(_vm.canvasTag,{ref:"gifCanvas",tag:"component",staticClass:"gif-canvas po",style:(_vm.mpGifStyle),attrs:{"type":_vm.getCanvasType,"canvasId":_vm.canvasId,"canvas-id":_vm.canvasId,"id":_vm.canvasId}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }